import { render, staticRenderFns } from "./AnimatedHeightTransition.vue?vue&type=template&id=26aadf7c&lang=pug"
import script from "./AnimatedHeightTransition.vue?vue&type=script&lang=ts"
export * from "./AnimatedHeightTransition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports